(function($){

	Fancybox.bind("[data-fancybox]", {
	  	placeFocusBack: false
	});

	
})(jQuery);